import React from "react"
import { Outlet } from "react-router-dom"
import { Navbar } from "../components/Navbar"

export const WebsiteLayout: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main>
        <Outlet />
      </main>
    </div>
  )
}
